import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './password-indicator.magic.css.js';
import script from './password-indicator.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"password-indicator",class:{ 'password-indicator--valid': _vm.isAllValid },attrs:{"part":_vm.$p('password-indicator', { 'password-indicator--valid': _vm.isAllValid })}},[_c('magic-ui-text',{staticClass:"title",attrs:{"tag":"h4","part":"title","content":_vm.$t('password-indicator.title')}}),_vm._v(" "),_c('ul',{staticClass:"list",attrs:{"part":"list","data-v-test-id":"password-indicator-list"}},_vm._l((_vm.currentStatus),function(status){return _c('li',{key:status.id,staticClass:"item",class:{ 'item--active': status.isValid },attrs:{"part":_vm.$p('item', { 'item--active': status.isValid })}},[_c('magic-ui-icon',{staticClass:"icon",attrs:{"part":"icon","name":"checked-solid"}}),_vm._v(" "),_c('magic-ui-text',{staticClass:"text",attrs:{"tag":"p","part":"text","content":_vm.$t(status.title, status.params)}})],1)}),0)],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-7f50ed61_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-7f50ed61";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
